import { i18n } from '@/plugins/i18n'

export const ticketStatus = {
    INIT:"INIT",
    FAILED:"FAILED",
    SUCCEED:"SUCCEED",
} 

export const terminalStatus = {
    INACTIVE : 0,
    ACTIVE : 1,
    BLOCKED_BY_SHAPARAK : 2
}

export const terminalStatusStr = {
    INACTIVE: i18n.t('terminal_status.inactive'),
    ACTIVE: i18n.t('terminal_status.active'),
    BLOCKED_BY_SHAPARAK: i18n.t('terminal_status.blocked_by_shaparak'),
    get(status) {
        let status_str = null;
        Object.keys(terminalStatus).forEach(function (item, index) {
            if(terminalStatus[item] === status) {
                status_str = terminalStatusStr[item]
            }
        })
        return status_str
    }
}

export const statusVariant = (status) => {
    if(status === terminalStatus.ACTIVE) {
        return 'success'
    }

    if(status === terminalStatus.INACTIVE) {
        return 'warning'
    }

    if(status === terminalStatus.BLOCKED_BY_SHAPARAK) {
        return 'danger'
    }

    else {
        return 'info'
    }
} 